export const fontFamily =
  '\'Roboto\', Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

export const fontWeights = {
  black: '900',
  bold: '700',
  regular: '400',
};

export const headings = {
  size1: {
    fontSize: '3rem',
    lineHeight: '3.5rem',
    letterSpacing: '-0.03125rem',
  },
  size2: {
    fontSize: '2rem',
    lineHeight: '2.5rem',
    letterSpacing: '0',
  },
  size3: {
    fontSize: '1.75rem',
    lineHeight: '2rem',
    letterSpacing: '0',
  },
  size4: {
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
    letterSpacing: '0',
  },
  size5: {
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
  },
  size6: {
    fontSize: '1.125rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
  },
  size7: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
  },
  size8: {
    fontSize: '0.85rem',
    lineHeight: '1.25rem',
    letterSpacing: '0',
  },
};

export const texts = {
  size1: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
  },
  size2: {
    fontSize: '0.875rem',
    lineHeight: '1rem',
    letterSpacing: '0',
  },
  size3: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    letterSpacing: '0',
  },
};

export const textsMobile = {
  size1: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
  },
  size2: {
    fontSize: '0.875rem',
    lineHeight: '1rem',
    letterSpacing: '0',
  },
  size3: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    letterSpacing: '0',
  },
};
